import React from "react";
import "./Loader.css";

export const LoadingSpinner = ({ size = "medium", className = "" }) => (
  <span className={`ui-loading-spinner ui-loading-spinner--${size} ${className}`.trim()} aria-hidden="true" />
);

export const ButtonLoader = ({ label = "Processing..." }) => (
  <span className="ui-button-loading" role="status" aria-live="polite">
    <LoadingSpinner size="small" />
    <span>{label}</span>
  </span>
);

export const SectionLoader = ({ label = "Loading...", rows = 3, compact = false, className = "" }) => (
  <div className={`ui-section-loader${compact ? " ui-section-loader--compact" : ""} ${className}`.trim()} role="status" aria-live="polite" aria-busy="true">
    <div className="ui-section-loader__heading"><LoadingSpinner /><span>{label}</span></div>
    <div className="ui-loading-skeleton" aria-hidden="true">
      {Array.from({ length: rows }, (_, index) => <span key={index} />)}
    </div>
  </div>
);

export const PageLoader = ({ label = "Loading page...", className = "" }) => (
  <div className={`ui-page-loader ${className}`.trim()} role="status" aria-live="polite" aria-busy="true">
    <LoadingSpinner size="large" />
    <strong>{label}</strong>
    <span>Please wait a moment.</span>
  </div>
);

export default PageLoader;
